"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTAPIErrorCodes = exports.APIError = exports.OpenAPIV3 = void 0;
exports.resolveComponent = resolveComponent;
const openapi_types_1 = require("openapi-types");
Object.defineProperty(exports, "OpenAPIV3", { enumerable: true, get: function () { return openapi_types_1.OpenAPIV3; } });
class APIError extends Error {
    constructor(status, message = "") {
        super(message);
        this.status = status;
    }
}
exports.APIError = APIError;
exports.RESTAPIErrorCodes = {
    0: "failed_connection",
    400: "bad_request",
    401: "unauthorized",
    403: "forbidden",
    404: "not_found",
    405: "method_not_allowed",
    500: "internal_server_error",
    501: "not_implemented",
    999: "unknown_error",
};
function resolveComponent(spec, obj, type) {
    var _a, _b;
    if (obj && "$ref" in obj) {
        const name = obj.$ref.split("/").slice(-1);
        return (_b = (_a = spec.components) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[name];
    }
    else {
        return obj;
    }
}
//# sourceMappingURL=types.js.map